export const OrdzhonikidzeData = [
    {
        title: "дом №1",
        year: '1962',
        floor: "2",
        apartment: "16",
        quantityLC: "18",
        livingArea: "544,7",
        notLivinigArea: "нет",
        commonProperty: "48,8",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'ordzhonikidze/sofrino_ordzhonikidze_41_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }
]